import { atom } from 'recoil';

export type ChatView = "KANBAN" | "CONVERSATIONS"

export const selectedChatView = atom<ChatView>({
  key: 'SELECTED_CHAT_VIEW',
  default: 'KANBAN'
});
